'use strict';
import { react2angular } from 'react2angular';
import PDFViewerWrapper from '../../src/components/PDFViewer/PDFViewerWrapper';

angular
    .module('dstreamApp.reactBridge')
    .component('dsPdfViewer', react2angular(PDFViewerWrapper, ['isNewInvoice', 'isFromDashboard', 'inline'], ['$rootScope']));
